import { useState } from "react";
import DatePickerField from "../../common/DatePickerField ";
import Input from "../../common/Input";
import SelectForm from "../../common/SelectForm";

const InfoUserForm = ({ formik, userGenderOption, handleOpenModal }) => {
  const [disabled, setDisabled] = useState(true);
  const enableForm = () => {
    setDisabled(!disabled);
  };
  const openModal = () => {
    handleOpenModal();
  };
  return (
    <>
      <div className="flex w-full md:w-1/3 px-3">
        <Input
          formik={formik}
          name="FirstNameSR"
          label="نام"
          type="text"
          disabled={disabled}
        />
      </div>
      <div className="flex w-full md:w-1/3 px-3">
        <Input
          formik={formik}
          name="LastNameSR"
          label="نام‌خانوادگی"
          type="text"
          disabled={disabled}
        />
      </div>
      <div className="flex w-full md:w-1/3 px-3">
        <Input
          formik={formik}
          name="Email"
          label="پست الکترونیک"
          type="text"
          disabled={disabled}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <Input
          formik={formik}
          name="MobileNumber"
          label="شماره موبایل"
          type="text"
          disabled={disabled}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <Input
          formik={formik}
          name="FatherNameSR"
          label="نام پدر"
          type="text"
          disabled={disabled}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3 text-sm">
        <DatePickerField
          label="تاریخ تولد"
          formik={formik}
          name="BirthDate"
          disabled={disabled}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <Input
          formik={formik}
          name="NationalityCode"
          label="کد ملی"
          type="text"
          disabled={disabled}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <Input
          formik={formik}
          name="PhoneNumber"
          label="شماره تلفن"
          type="text"
          disabled={disabled}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <SelectForm
          formik={formik}
          name="Gender"
          label="جنسیت"
          options={userGenderOption}
          disabled={disabled}
        />
      </div>

      <div className="flex gap-4 px-3">
        <button
          onClick={enableForm}
          type="button"
          className={`${
            !disabled ? "hidden" : ""
          } mt-2 bg-darkGreenKite text-white text-center rounded-md py-2 px-4`}
        >
          ویرایش
        </button>
        <button
          onClick={openModal}
          type="button"
          className={`${
            !disabled ? "hidden" : ""
          } mt-2 bg-darkGreenKite text-white text-center rounded-md py-2 px-4`}
        >
          تغییر رمز
        </button>
        <button
          onClick={enableForm}
          type="button"
          className={`${
            disabled ? "hidden" : ""
          } mt-2 bg-red-600 text-white text-center rounded-md py-2 px-4`}
        >
          انصراف
        </button>
        <button
          type="submit"
          disabled={!formik.isValid}
          className={`${
            disabled ? "hidden" : ""
          } mt-2 disabled:bg-lightGrayKite disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4`}
        >
          {formik.isSubmitting ? "در حال ارسال فرم" : "ثبت اطلاعات"}
        </button>
      </div>
    </>
  );
};

export default InfoUserForm;
